<template>
	<div>
    <router-link to="/create_client">
      <button 
      class="trial-button"
      :class="{ small: small, large: large}">
      <div v-if="size == 'small'">
        <p>無料トライアルはこちら</p>
      </div>
      <div v-else-if="size == 'large'">
        <p class="small-p">まずは14日間HRモンスターを体験してみませんか？</p>
        <p class="large-p">無料トライアルはこちら</p>
      </div>
      </button>
    </router-link>
	</div>
</template>

<script>
export default {
  name: 'TrialButton',
  props: {
    size: {
      type: String,
      required: false
    }
  },
  computed: {
    small () {
      if (this.size == 'small') return true
    },
    large () {
      if (this.size == 'large') return true
    }
  }
}
</script>

<style lang="scss" scoped>
.trial-button {
  background: -moz-linear-gradient(left, #89EFF6, #00BBC6);
  background: -webkit-linear-gradient(left, #89EFF6, #00BBC6);
  background: linear-gradient(to right, #89EFF6, #00BBC6);
	color: #ffffff;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.small {
  width: 200px;
  height: 40px;
  font-size: 14px;
}
.large {
  width: 400px;
  height: 96px;
  .small-p {
    font-size: 12px;
    width: 100%;
  }
  .large-p {
    font-size: 24px;
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .large {
    width: 304px;
    height: 80px;
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/TrialButton.vue